// extracted by mini-css-extract-plugin
module.exports = {"duelCancel":"DuelCancel_duelCancel__3-K9f","wrapper":"DuelCancel_wrapper__373l6","message":"DuelCancel_message__3iScI"};